import { render } from "./ContactMessage.vue?vue&type=template&id=fd11a1bc&scoped=true&ts=true"
import script from "./ContactMessage.vue?vue&type=script&lang=ts"
export * from "./ContactMessage.vue?vue&type=script&lang=ts"

import "./ContactMessage.vue?vue&type=style&index=0&id=fd11a1bc&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd11a1bc"]])

export default __exports__